import React from 'react';
import { Label } from 'semantic-ui-react';
import '../style/App.css';
import {PageType} from '../types';
import FrontPage from './FrontPage';
import SimplePage from './SimplePage';
import SimpleCard from './SimpleCard';
import ColumnsPage from './ColumnsPage';
import Slider from './Slider';
import SlideShowPage from './SlideShowPage';
import config from '../config';

const renderPage = (page) => {
    if(!page || !page.type){
        return null;
    } 
    switch(page.type){
        case PageType.FrontPage:
            return (<FrontPage {...page}/>)
        case PageType.SimpleCard:
            return (<SimpleCard {...page}/>)
        case PageType.ColumnsPage:
            return (<ColumnsPage {...page}/>)
        case PageType.SimplePage:
            return (<SimplePage {...page}/>)
        case PageType.Slider:
            return (<Slider {...page}/>)
        case PageType.SlideShowPage:
            return (<SlideShowPage {...page}/>)
        default:
            return null;
    }
}

class Page extends React.Component{
    render(){
        //alert(this.props.type);
        const style = this.props.type === PageType.FrontPage ? 
        Style.frontPage : Style.page;
        return(
            <div id={this.props.link} style={style}>
                {this.props.title &&  !this.props.noHeader &&
                <Label style={{...Style.header, ...config.website.page.style }} size='large'>
                    {this.props.title}
                </Label> }
                <div >
                    {renderPage({...this.props})}
                </div>
            </div>
        )
    }

};

const Style = {
    header: {
        width: '100%',
        height: 'auto',
        color: '#e1e1a2',
        fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
        fontSize: '34px',
        fontWeight: '900',
        marginTop: '30px',
        background: 'white'
    },
    page: {
        padding:'8% 13% 1% 13%', 
    },
    frontPage: {
        marginTop: '5em',  
        padding:'5px 1% 1% %', 
    }
}
export default Page;


// WEBPACK FOOTER //
// ./src/components/Page.js